/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const LABELS = {
  SAVE: 'Save',
  DONE: 'Done',
  NEXT: 'Next',
  NO_VALUE: '--',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  GENERAL: 'General',
  ROLES: 'Roles',
  IDENTIFIER: 'Identifier',
  DESCRIPTION: 'Description',
  DISPLAY_NAME: 'Display Name',
  ROWS_PER_PAGE_LABEL: 'Rows per page',
  DELETE_USER_GROUP: 'Delete User Group',
  DELETE_CONFIRMATION: 'Are you sure you want to delete ',
};

export const MESSAGES = {
  USER_GROUP_CREATED: 'User group: {0} created successfully',
  USER_GROUP_UPDATED: 'User group: {0} updated successfully',
  USER_GROUP_DELETED: 'User group: {0} deleted successfully',
  USER_GROUP_CREATE_FAILED: 'Error while creating user group: {0}',
  DELETE_CONFIRMATION: 'Are you sure you want to delete this user group?',
  IDENTIFIER_REQUIRED: 'Identifier is required and length should be between 2 to 128 characters',
  DISPLAY_NAME_REQUIRED: 'Display Name is required and length should be between 2 to 128 characters',
  IDENTIFIER_INVALID: 'Identifier is invalid, it should be alphanumeric and can only contain _-]+$ characters.',
  DISPLAY_NAME_INVALID: 'Display Name is invalid, it should be alphanumeric and can only contain _-]+$ characters.',
  DELETE_USER_GROUP_TEXT: "Are you sure you want to delete the User Group {name} ?",
  DESCRIPTION_REQUIRED: 'Description is required and length should be between 2 to 256 characters',
};